"use strict";
/*!
 * Copyright 2018 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var assert = require("assert");

var logger_1 = require("./logger");

var util_1 = require("./util");

exports.CLIENT_TERMINATED_ERROR_MSG = 'The client has already been terminated';
/**
 * An auto-resizing pool that distributes concurrent operations over multiple
 * clients of type `T`.
 *
 * ClientPool is used within Firestore to manage a pool of GAPIC clients and
 * automatically initializes multiple clients if we issue more than 100
 * concurrent operations.
 *
 * @private
 * @internal
 */

var ClientPool =
/*#__PURE__*/
function () {
  /**
   * @param concurrentOperationLimit The number of operations that each client
   * can handle.
   * @param maxIdleClients The maximum number of idle clients to keep before
   * garbage collecting.
   * @param clientFactory A factory function called as needed when new clients
   * are required.
   * @param clientDestructor A cleanup function that is called when a client is
   * disposed of.
   */
  function ClientPool(concurrentOperationLimit, maxIdleClients, clientFactory) {
    var clientDestructor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return Promise.resolve();
    };

    _classCallCheck(this, ClientPool);

    this.concurrentOperationLimit = concurrentOperationLimit;
    this.maxIdleClients = maxIdleClients;
    this.clientFactory = clientFactory;
    this.clientDestructor = clientDestructor;
    /**
     * Stores each active clients and how many operations it has outstanding.
     */

    this.activeClients = new Map();
    /**
     * A set of clients that have seen RST_STREAM errors (see
     * https://github.com/googleapis/nodejs-firestore/issues/1023) and should
     * no longer be used.
     */

    this.failedClients = new Set();
    /**
     * Whether the Firestore instance has been terminated. Once terminated, the
     * ClientPool can longer schedule new operations.
     */

    this.terminated = false;
    /**
     * Deferred promise that is resolved when there are no active operations on
     * the client pool after terminate() has been called.
     */

    this.terminateDeferred = new util_1.Deferred();
  }
  /**
   * Returns an already existing client if it has less than the maximum number
   * of concurrent operations or initializes and returns a new client.
   *
   * @private
   * @internal
   */


  _createClass(ClientPool, [{
    key: "acquire",
    value: function acquire(requestTag) {
      var selectedClient = null;
      var selectedClientRequestCount = -1;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.activeClients[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var client = _ref2[0];
          var requestCount = _ref2[1];

          // Use the "most-full" client that can still accommodate the request
          // in order to maximize the number of idle clients as operations start to
          // complete.
          if (!this.failedClients.has(client) && requestCount > selectedClientRequestCount && requestCount < this.concurrentOperationLimit) {
            selectedClient = client;
            selectedClientRequestCount = requestCount;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (selectedClient) {
        logger_1.logger('ClientPool.acquire', requestTag, 'Re-using existing client with %s remaining operations', this.concurrentOperationLimit - selectedClientRequestCount);
      } else {
        logger_1.logger('ClientPool.acquire', requestTag, 'Creating a new client');
        selectedClient = this.clientFactory();
        selectedClientRequestCount = 0;
        assert(!this.activeClients.has(selectedClient), 'The provided client factory returned an existing instance');
      }

      this.activeClients.set(selectedClient, selectedClientRequestCount + 1);
      return selectedClient;
    }
    /**
     * Reduces the number of operations for the provided client, potentially
     * removing it from the pool of active clients.
     * @private
     * @internal
     */

  }, {
    key: "release",
    value: function release(requestTag, client) {
      var requestCount;
      return _regeneratorRuntime.async(function release$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestCount = this.activeClients.get(client) || 0;
              assert(requestCount > 0, 'No active requests');
              this.activeClients.set(client, requestCount - 1);

              if (this.terminated && this.opCount === 0) {
                this.terminateDeferred.resolve();
              }

              if (!this.shouldGarbageCollectClient(client)) {
                _context.next = 10;
                break;
              }

              this.activeClients.delete(client);
              this.failedClients.delete(client);
              _context.next = 9;
              return _regeneratorRuntime.awrap(this.clientDestructor(client));

            case 9:
              logger_1.logger('ClientPool.release', requestTag, 'Garbage collected 1 client');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
    /**
     * Given the current operation counts, determines if the given client should
     * be garbage collected.
     * @private
     * @internal
     */

  }, {
    key: "shouldGarbageCollectClient",
    value: function shouldGarbageCollectClient(client) {
      // Don't garbage collect clients that have active requests.
      if (this.activeClients.get(client) !== 0) {
        return false;
      } // Idle clients that have received RST_STREAM errors are always garbage
      // collected.


      if (this.failedClients.has(client)) {
        return true;
      } // Otherwise, only garbage collect if we have too much idle capacity (e.g.
      // more than 100 idle capacity with default settings) .


      var idleCapacityCount = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.activeClients[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref6 = _step2.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var count = _ref5[1];
          idleCapacityCount += this.concurrentOperationLimit - count;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return idleCapacityCount > this.maxIdleClients * this.concurrentOperationLimit;
    }
    /**
     * The number of currently registered clients.
     *
     * @return Number of currently registered clients.
     * @private
     * @internal
     */
    // Visible for testing.

  }, {
    key: "run",

    /**
     * Runs the provided operation in this pool. This function may create an
     * additional client if all existing clients already operate at the concurrent
     * operation limit.
     *
     * @param requestTag A unique client-assigned identifier for this operation.
     * @param op A callback function that returns a Promise. The client T will
     * be returned to the pool when callback finishes.
     * @return A Promise that resolves with the result of `op`.
     * @private
     * @internal
     */
    value: function run(requestTag, op) {
      var _this = this;

      if (this.terminated) {
        return Promise.reject(new Error(exports.CLIENT_TERMINATED_ERROR_MSG));
      }

      var client = this.acquire(requestTag);
      return op(client).catch(function _callee(err) {
        var _a;

        return _regeneratorRuntime.async(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_a = err.message) === null || _a === void 0 ? void 0 : _a.match(/RST_STREAM/)) {
                  // Once a client has seen a RST_STREAM error, the GRPC channel can
                  // no longer be used. We mark the client as failed, which ensures that
                  // we open a new GRPC channel for the next request.
                  _this.failedClients.add(client);
                }

                _context2.next = 3;
                return _regeneratorRuntime.awrap(_this.release(requestTag, client));

              case 3:
                return _context2.abrupt("return", Promise.reject(err));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        });
      }).then(function _callee2(res) {
        return _regeneratorRuntime.async(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _regeneratorRuntime.awrap(_this.release(requestTag, client));

              case 2:
                return _context3.abrupt("return", res);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        });
      });
    }
  }, {
    key: "terminate",
    value: function terminate() {
      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref9, _ref8, client;

      return _regeneratorRuntime.async(function terminate$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this.terminated = true; // Wait for all pending operations to complete before terminating.

              if (!(this.opCount > 0)) {
                _context4.next = 5;
                break;
              }

              logger_1.logger('ClientPool.terminate',
              /* requestTag= */
              null, 'Waiting for %s pending operations to complete before terminating', this.opCount);
              _context4.next = 5;
              return _regeneratorRuntime.awrap(this.terminateDeferred.promise);

            case 5:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context4.prev = 8;
              _iterator3 = this.activeClients[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context4.next = 20;
                break;
              }

              _ref9 = _step3.value;
              _ref8 = _slicedToArray(_ref9, 1);
              client = _ref8[0];
              this.activeClients.delete(client);
              _context4.next = 17;
              return _regeneratorRuntime.awrap(this.clientDestructor(client));

            case 17:
              _iteratorNormalCompletion3 = true;
              _context4.next = 10;
              break;

            case 20:
              _context4.next = 26;
              break;

            case 22:
              _context4.prev = 22;
              _context4.t0 = _context4["catch"](8);
              _didIteratorError3 = true;
              _iteratorError3 = _context4.t0;

            case 26:
              _context4.prev = 26;
              _context4.prev = 27;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 29:
              _context4.prev = 29;

              if (!_didIteratorError3) {
                _context4.next = 32;
                break;
              }

              throw _iteratorError3;

            case 32:
              return _context4.finish(29);

            case 33:
              return _context4.finish(26);

            case 34:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this, [[8, 22, 26, 34], [27,, 29, 33]]);
    }
  }, {
    key: "size",
    get: function get() {
      return this.activeClients.size;
    }
    /**
     * The number of currently active operations.
     *
     * @return Number of currently active operations.
     * @private
     * @internal
     */
    // Visible for testing.

  }, {
    key: "opCount",
    get: function get() {
      var activeOperationCount = 0;
      this.activeClients.forEach(function (count) {
        return activeOperationCount += count;
      });
      return activeOperationCount;
    }
  }]);

  return ClientPool;
}();

exports.ClientPool = ClientPool;